import { render, staticRenderFns } from "./AppAccordion.vue?vue&type=template&id=0127623b&scoped=true"
import script from "./AppAccordion.vue?vue&type=script&lang=js"
export * from "./AppAccordion.vue?vue&type=script&lang=js"
import style0 from "./AppAccordion.vue?vue&type=style&index=0&id=0127623b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0127623b",
  null
  
)

export default component.exports